<template lang="html">
  <div class="wcc result" v-if="value > 0">
    <span>{{label}}</span><span>${{numberWithCommas(trailingZeros(value))}}</span>
  </div>
</template>
<script>
  export default {
    props: [
      'label',
      'value'
    ],
    methods: {
      trailingZeros(float) {
        let string = String(float)
        if (string.indexOf('.') > -1) {
          return float.toFixed(2)
        } else {
          return float
        }
      }
    }
  }
</script>
<style lang="scss">

section.wcc.results-container {
  .wcc.result-group {
    .wcc.result {
      display: flex;
      justify-content: space-between;
      margin-bottom: .25em;
    }
  }
}

</style>